export default __webpack_public_path__ + "static/media/Aura-Egg__69.063d3f17.png";